import { useState, useEffect } from 'react';
import cn from 'clsx';

export interface Tab {
  label?: string;
  value: string | number;
  public?: boolean;
}

interface TabsProps extends Omit<React.HTMLProps<HTMLDivElement>, 'onChange'> {
  active?: Tab;
  tabs?: Tab[];
  onChange?: (tab: Tab) => void;
}

const Tabs: React.FC<TabsProps> = ({
  className,
  active,
  tabs,
  onChange,
  ...props
}) => {
  const [selected, setSelected] = useState<Tab | undefined>(active);

  const rootCn = cn(
    'flex justify-around border-black gap-2 uppercase font-display font-bold text-sm',
    className
  );

  useEffect(() => {
    if (selected) onChange?.(selected);
  }, [selected, onChange]);

  return (
    <div className={rootCn} {...props}>
      {tabs?.map((tab, i) => {
        const onClick = () => {
          setSelected(tab);
        };

        const tabCn = cn(
          'flex-1 flex justify-center py-2 cursor-pointer hover:underline border-3 border-black text-center px-1',
          {
            'bg-white hover:bg-gray-50': selected?.value !== tab.value,
            'bg-black text-white': selected?.value === tab.value,
          }
        );

        return (
          <div key={`tab-${tab.value}`} className={tabCn} onClick={onClick}>
            {tab.label || tab.value}
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
